<template>
  <main class="vegas">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/vegas/menu.vue';
import hero from '@/components/vegas/hero.vue';
import agenda from '@/components/vegas/agenda.vue';
import sponsors from '@/components/vegas/sponsors.vue';
import speakers from '@/components/vegas/speakers.vue';
import presenters from '@/components/vegas/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .vegas {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>